import React, { Suspense, lazy, useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./components/common/ScrollToTop";
import { RootState } from "./redux/store";
import { useSelector } from "react-redux";
import GenerateLoader from "./components/common/GenerateLoader";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { GetUserProfile } from "./redux/actions/UserAction";
import { GetAllStories } from "./redux/actions/StoryAction";
import {
  GetCurrentPlan,
  GetUpcommingPlan,
} from "./redux/actions/SubscriptionAction";
import { Analytics } from "@vercel/analytics/react";
import { getAllImagesByUser } from "./redux/actions/ImageAction";
import LogRocket from "logrocket";
import { ClerkAuth, userLogout } from "./redux/actions/AuthAction";
import { useAuth, useUser } from "@clerk/clerk-react";
import { useClerkAuth } from "./context/ClerkAuthContext";
import CreateLayout from "./layouts/CreateLayout";
import Layout from "./layouts/Layout";
import { FallbackProvider } from "./context/FallbackProvider";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ShareExperiencePage from "./pages/ShareExperiencePage";
import SsoCallback from "./pages/SsoCallback";

const Create = lazy(() => import("./pages/Create"));
const MyStories = lazy(() => import("./pages/MyStories"));
const Profile = lazy(() => import("./pages/Profile"));
const EditProfile = lazy(() => import("./pages/EditProfile"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Index = lazy(() => import("./index/Index"));
const NotFound = lazy(() => import("./components/common/NotFound"));
const PrivacyPolicy = lazy(() => import("./legal/PrivacyPolicy"));
const HelpSupport = lazy(() => import("./pages/HelpSupport"));
const Notifications = lazy(() => import("./pages/Notifications"));
const Settings = lazy(() => import("./pages/Settings"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const Authenticate = lazy(() => import("./pages/Authenticate"));
const TermsOfService = lazy(() => import("./legal/TermsOfService"));
const MyPlans = lazy(() => import("./pages/MyPlans"));
const Success = lazy(() => import("./pages/subscription/Success"));
const Cancel = lazy(() => import("./pages/subscription/Cancel"));
const Transactions = lazy(() => import("./pages/Transactions"));
const ViewStory = lazy(() => import("./pages/ViewStory"));
const ViewImage = lazy(() => import("./pages/ViewImage"));
const LessonPlan = lazy(() => import("./pages/LessonPlan"));
const LessonPlanV2 = lazy(() => import("./pages/LessonPlanV2"));
const LessonConversation = lazy(() => import("./pages/LessonConversation"));
const ViewSharedLessonConversation = lazy(
  () => import("./pages/ViewSharedLessonConversation")
);

function App() {
  LogRocket.init("azeoo6/comicfy");
  const { isSignedIn, isSynced, user } = useClerkAuth();

  const Auth = useSelector((state: RootState) => state.Auth);
  const Story = useSelector((state: RootState) => state.Story);
  const Image = useSelector((state: RootState) => state.Image);
  const dispatch = useDispatch();

  const [loaderloading, setLoaderLoading] = useState(false);
  const [isLogin, setIsLogin] = useState<boolean>(
    !!localStorage.getItem("uid")
  );

  // useEffect(() => {
  //   if (Auth.isLogin && Auth.uid !== "") {
  //     getUserProfile(Auth.uid);
  //     getAllstories(Auth.uid);
  //     getAllImages(Auth.uid);
  //     getcurrentplan(Auth.uid);
  //     GetUpcommingPlan(Auth.uid);
  //     localStorage.setItem("uid", Auth.uid);

  //     if (!!!localStorage.getItem("method")) {
  //       localStorage.setItem("method", Auth.loginMethod);
  //     }

  //     setIsLogin(true);
  //   } else {
  //     if (
  //       localStorage.getItem("uid") &&
  //       localStorage.getItem("uid") !== "" &&
  //       localStorage.getItem("uid") !== "null"
  //     ) {
  //       setIsLogin(true);
  //     } else {
  //       window.scrollTo({ top: 0 });
  //       setIsLogin(false);
  //     }
  //   }

  //   const handleStorageChange = () => {
  //     const uid = localStorage.getItem("uid");
  //     if (!uid || uid === "" || uid === "null") {
  //       setIsLogin(false);
  //       logout();
  //     } else {
  //       setIsLogin(true);
  //     }
  //   };

  //   window.addEventListener("storage", handleStorageChange);
  //   return () => {
  //     window.removeEventListener("storage", handleStorageChange);
  //   };
  // }, [Auth.isLogin, Auth.uid]);

  useEffect(() => {
    setLoaderLoading(Story.generate_loading || Image.generate_loading);
  }, [Story.generate_loading, Image.generate_loading]);
  return (
    <div className="App">
      <Analytics />
      <GenerateLoader loading={loaderloading} />
      <BrowserRouter>
        <ScrollToTop />
        <ToastContainer
          stacked={true}
          closeButton={true}
          className="toast-position"
          autoClose={1800}
          position="top-center"
          draggable={true}
          hideProgressBar={true}
        />
        {typeof isSignedIn === "undefined" || (isSignedIn && !isSynced) ? null : (
          <Suspense fallback={null}>
            {isSignedIn ? (
              <CreateLayout>
                <FallbackProvider>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/create" element={<Create />} />
                    <Route path="/mystories" element={<MyStories />} />
                    <Route path="/view-story/:storyId" element={<ViewStory />} />
                    <Route path="/view-image/:imageId" element={<ViewImage />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/edit-profile" element={<EditProfile />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-of-service" element={<TermsOfService />} />
                    <Route path="/help" element={<HelpSupport />} />
                    <Route path="/notifications" element={<Notifications />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/all-transactions" element={<Transactions />} />
                    {/* <Route path="/lesson-plan" element={<LessonPlan />} /> */}
                    <Route path="/lesson-plan" element={<LessonPlanV2 />} />
                    <Route
                      path="/lesson-plan/conversation/:lessonId?"
                      element={<LessonConversation />}
                    />
                    <Route
                      path="/view-lesson-plan/conversation/:lessonId?"
                      element={
                        <ViewSharedLessonConversation isLogin={isSignedIn} />
                      }
                    />
                    <Route
                      path="/reset-password/:token"
                      element={<ResetPassword />}
                    />
                    <Route path="/authenticate" element={<Authenticate />} />
                    <Route path="/myplans" element={<MyPlans />} />
                    <Route path="/subscription/success" element={<Success />} />
                    <Route path="/subscription/cancel" element={<Cancel />} />
                    <Route path="/share-experience" element={<ShareExperiencePage />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </FallbackProvider>
              </CreateLayout>
            ) : (
              <Layout>
                <FallbackProvider>
                  <Routes>
                    <Route path="/" element={<Index />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/sso-callback" element={<SsoCallback />} />
                    <Route path="/help" element={<HelpSupport />} />
                    <Route path="/view-story/:storyId" element={<ViewStory />} />
                    <Route path="/view-image/:imageId" element={<ViewImage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-of-service" element={<TermsOfService />} />
                    <Route path="/share-experience" element={<ShareExperiencePage />} />
                    <Route
                      path="/view-lesson-plan/conversation/:lessonId?"
                      element={
                        <ViewSharedLessonConversation isLogin={isSignedIn} />
                      }
                    />
                    <Route
                      path="/reset-password/:token/:expiration"
                      element={<ResetPassword />}
                    />
                    <Route path="/authenticate" element={<Authenticate />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </FallbackProvider>
              </Layout>
            )}
          </Suspense>
        )}

      </BrowserRouter >
    </div >
  );
}

export default App;
